/* eslint no-mixed-operators:0 */
/* eslint no-shadow:0 */
import helpers from '@/utils/helpers';
import secureValidation from '@/utils/secureValidation';

const required = (propertyType) => (v) => v && v.length > 0 || `${propertyType} field is required`;

const minLength = (propertyType, minLength) => (v) => (v === '' || v && v.length >= minLength) || `${propertyType} must not be less than ${minLength} characters`;

const confirmPassword = (propertyType, password) => (v) => v && v === password || `${propertyType} must be same as entered password`;

const maxLength = (propertyType, maxLength) => (v) => v && v.length <= maxLength || `${propertyType} must be less than ${maxLength}`;

const max = (propertyType, max) => (v) => v && v <= max || `${propertyType} must not be more than ${max}`;

const min = (propertyType, min) => (v) => v && v >= min || `${propertyType} must be ${min} or more`;

const minAmount = (propertyType, num) => (v) => helpers.stringToNumber(v) && helpers.stringToNumber(v) >= num || `${propertyType} must be Ksh ${helpers.numberToString(num)} or more`;

const emailFormat = () => (v) => v && secureValidation.validateEmail(v) || 'Must be a valid email';

const mobileFormat = () => {
  const regex = /^\+254\d{9}$/; // [- ]?
  return (v) => v && regex.test(v) || 'Must start with +254...';
};

const kraPinFormat = () => {
  const regex = /^a\d{9}[a-z]$/i;
  return (v) => v && regex.test(v) || 'Must be a valid KRA PIN';
};

const numberFormat = () => {
  const regex = /^\d+$/;
  return (v) => v && regex.test(v) || 'Must be a valid number';
};

const lowerCaseFormat = () => (v) => v && secureValidation.hasLowercase(v) || 'Must have at least 1 lowercase character';
const upperCaseFormat = () => (v) => v && secureValidation.hasUppercase(v) || 'Must have at least 1 uppercase character';

const digitFormat = () => (v) => v && secureValidation.hasDigit(v) || 'Must have at least 1 digit';

const specialCharFormat = () => (v) => v && secureValidation.hasSpecialChar(v) || 'Must have at least 1 special character';

const numberPlateFormat = () => {
  const regex = helpers.getNumberPlateRegex();
  return (v) => v && regex.test(v.replace(/\s+/g, '').toUpperCase()) || 'Registration Number must be valid';
};

const isObjectField = () => (v) => v && typeof v === 'object' || 'Must be valid object';

const check = () => (v) => v === true || 'You must agree to continue!';

export default {
  required,
  minLength,
  maxLength,
  emailFormat,
  numberFormat,
  kraPinFormat,
  confirmPassword,
  check,
  mobileFormat,
  lowerCaseFormat,
  minAmount,
  max,
  min,
  isObjectField,
  numberPlateFormat,
  upperCaseFormat,
  digitFormat,
  specialCharFormat,
};
